export const mergeClasses = (...classNames: string[]): string => classNames.join(' ');
